import PropTypes from 'prop-types';
import React from 'react';
import LockIcon from '../LockIcon';
import en from '../../intl/translations/en';

const SubHeader = ({ onClickPaywall, href }) => (
  <div className="sl-sub-header">
    <div className="sl-sub-header__icon">
      <LockIcon />
    </div>
    <div className="sl-sub-header__text">
      {en.premiumCTA.SubHeader.textBefore}
      <span className="sl-sub-header__text--hidden">{en.premiumCTA.SubHeader.text}</span>
      {en.premiumCTA.SubHeader.textAfter}
    </div>
    <a className="sl-sub-header__link" href={href} onClick={onClickPaywall}>
      {en.premiumCTA.SubHeader.linkText}
    </a>
  </div>
);

SubHeader.defaultProps = {
  onClickPaywall: null,
  href: null,
};

SubHeader.propTypes = {
  onClickPaywall: PropTypes.func,
  href: PropTypes.string,
};

export default SubHeader;
